import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  
  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          🏗️ BizAir24.com
        </Link>
        
        <div className="header-icons">
          <button className="icon-btn">🔍</button>
          <button className="icon-btn">✉️</button>
        </div>
      </div>

      {/* Show Back button only on details page */}
      {location.pathname !== '/' && (
        <div className="back-section">
          <Link to="/" className="back-btn">
            ← Back to Feed
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;